import { NFTBgColors, NFTColors, NFTHandColors } from 'shared';

export const blueBackground = '#4EABF4';
export const greenBackground = '#04AC66';

export interface ColorSchema {
  hand: string;
  text: string;
  backgrounds: {
    nft: string;
    main: string;
    dark: string;
    active: string;
    disabled: string;
    pressed: string;
  };
  shadows: {
    main: string;
    pressed: string;
    dark: string;
  };
  icons: {
    active: string;
    pressed: string;
  };
}

const toBlue = (mainColor: string, nftBackground: string): ColorSchema => ({
  hand: mainColor,
  text: '#F3933A',
  backgrounds: {
    nft: nftBackground,
    main: blueBackground,
    dark: '#135386',
    active: '#8DCDFF',
    disabled: '#1870B6',
    pressed: '#FFCA99BF'
  },
  shadows: {
    main: '#1870B6',
    pressed: '#1870B6',
    dark: '#0F3E64'
  },
  icons: {
    active: '#000',
    pressed: '#F47907'
  }
});

const toGreen = (handColor: string, nftBackground: string): ColorSchema => ({
  hand: handColor,
  text: '#E564B3',
  backgrounds: {
    nft: nftBackground,
    main: greenBackground,
    dark: '#184331',
    active: '#3AF3A5',
    disabled: '#1B7B53',
    pressed: '#FFB8E3BF'
  },
  shadows: {
    main: '#1B7B53',
    pressed: '#184331',
    dark: '#133326'
  },
  icons: {
    active: '#000',
    pressed: '#EC57B2'
  }
});

export const getColorSchemaByNFTColors = (
  colors: NFTColors,
  mode: 'blue' | 'green' = 'blue'
): ColorSchema => {
  const transformer = mode === 'blue' ? toBlue : toGreen;
  return transformer(toHandColor(colors.hand), toBgColor(colors.background));
};

export const toHandColor = (input: NFTHandColors): string => {
  switch (input) {
    case NFTHandColors.YELLOW:
      return '#f0bf16';
    case NFTHandColors.DARK:
      return '#764736';
    case NFTHandColors.TANNED:
      return '#b57961';
    case NFTHandColors.PALE:
      return '#e6ccb2';
    default: //PORCELAN
      return '#e2c2cc';
  }
};

export const toBgColor = (input: NFTBgColors): string => {
  switch (input) {
    case NFTBgColors.NEON:
      return '#c93a80';
    case NFTBgColors.ORIGINAL:
      return '#482893';
    default: //BLUE
      return '#1475c7';
  }
};
